import React, { Component, Fragment } from 'react'
import { Translate } from '../../contexts/Language';
import { BreadCrumb, Card, Modal } from '../../components';
import { Config } from '../../config';
import { Service } from '../../services';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { ErrorMessage, Validator, VRules, VConditions } from '../../components/Validator';

export class CryptoWallet extends Component {
    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            dataTable: {
                columns: DataTableColumns.cryptoWallet,
                rows: []
            },
            avaibleBalance: 0,
            pendingBalance: 0,
            modal: false,
            validation: {
                error: false,
                message: ""
            },
            formData: {
                address: "",
                amount: 0,
                comment: "",
                authCode: ""
            }
        }
        this.onSave = this.onSave.bind(this);
        this.dataTableRows = [];
    }
    componentDidMount() {
        this.onDatatable();
    }
    onDatatable() {
        Config.utilities.loadingFetch();

        Service.CryptoService.List().then(response => {

            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = Array.isArray(response.list) ? response.list : [];
                this.dataTableRows = Array.isArray(response.list) ? response.list : []

                this.setState({
                    dataTable: dataTable,
                    avaibleBalance: response.avaibleBalance,
                    pendingBalance: response.pendingBalance
                });

            }

            Config.utilities.loadingFetch();
        });
    }

    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }
    onModal() {
        this.setState({
            modal: true
        });
    }
    isValid(data) {


        VRules["address"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Address can not be empty.")
        }
        VRules["comment"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Comment can not be empty.")
        }
        VRules["authCode"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Auth Code can not be empty.")
        }



        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error
        });

        return !error.error;
    }

    onSave() {
        if (this.isValid(this.state.formData)) {
            Config.utilities.loadingFetch();

            Service.CryptoService.Coinwithdraw(this.state.formData).then(response => {

                if (response) {
                    this.setState({
                        validation: response
                    });
                    if (!response.error) {
                        this.setState({
                            modal: false
                        })
                        this.onDatatable();
                    }
                }

                Config.utilities.loadingFetch();
            });
        }

    }
    onSearch(login) {

        let filteredRows = [];
        if (login === "") {
            filteredRows = this.dataTableRows;
        }
        else {
            filteredRows = this.dataTableRows.filter(item => item.login === login);
        }
        if (filteredRows.length > 0) {
            let dataTable = this.state.dataTable;
            dataTable.rows = filteredRows;
            this.setState({
                dataTable
            });
        }

    }

    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Wallet")} Name={Translate("Wallet")} />
                <Card Title="Wallet" Description="BTC Transaction History">
                    <Modal Title={Translate("BTC Withdrawal")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                        <div className="row mt-1 mb-1">
                            <p className="text-muted mb-2 ml-1 col-md-12 font-12">BTC Withdrawal</p>
                            <div className="col-md-12">
                                <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                    <ErrorMessage Validation={this.state.validation} />
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Address</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="address" name="address" autoComplete="off" value={this.state.formData.address} onChange={(e) => this.onFormChange(e.target.value, "address")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Amount</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="number" id="amount" name="amount" autoComplete="off" value={this.state.formData.amount} onChange={(e) => this.onFormChange(e.target.value, "amount")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Comment</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="comment" name="comment" autoComplete="off" value={this.state.formData.comment} onChange={(e) => this.onFormChange(e.target.value, "comment")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Google Auth. Code</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="authCode" name="authCode" autoComplete="off" value={this.state.formData.authCode} onChange={(e) => this.onFormChange(e.target.value, "authCode")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                        <div className="col-sm-8">
                                            <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i> Save Form</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal>
                    <div className="row">
                        
                        <div className="col-md-3">
                            <div class="alert alert-success">
                                <strong>Avaible Balance: </strong>
                                <span>{this.state.avaibleBalance} BTC</span>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div class="alert alert-warning">
                                <strong>Pending Balance: </strong>
                                <span>{this.state.pendingBalance} BTC</span>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <button type="button" className="btn btn-danger position-absolute add-new-button tabless" onClick={(e) => this.onModal()}><i className="fas fa-coins mr-1"></i> BTC Withdrawal</button>
                            <input type="text" className="form-control col-md-2 mb-3" placeholder="Filter Login" onChange={(e) => this.onSearch(e.target.value)} />
                            {this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={this.state.dataTable.columns}
                                    data={this.state.dataTable.rows}
                                    pagination
                                    highlightOnHover />)}
                        </div>
                    </div>
                </Card>
            </Fragment>)
    }
}